<template>
    <b-modal
        id="modal-dialog" 
        v-show="false" 
        v-model="show"
        :headerClass="headerClass"
        :bodyClass="bodyClass"
        :noCloseOnEsc="noCloseOnEsc"
        :noCloseOnBackdrop="noCloseOnBackdrop"
        @hide="close(false)"
    >
        <template #modal-header="{ close }">
            <h5 
                v-if="
                    title || icon
                " 
                class="modal-title text-center" 
                :class="titleClass"
            >
                <i 
                    v-if="icon" 
                    :class="icon" 
                    class="modal-title-icon"
                />
                {{ title }}
            </h5>
            <button 
                v-if="title"
                type="button" 
                aria-label="Close" 
                class="close"
                @click="close()"
            >
                ×
            </button>
        </template>
        <template>
            <div 
                :class="bodyClassContent" 
                v-html="message"
            />
        </template>
        <div v-if="ia_tools.conteudoShow">
            <div class="caixa-ia-resposta">
                <div class="conteudo text-left" v-html="ia_tools.conteudo.replace(/\n/g, '<br/>')"></div>
                <p class="aviso-gerado">
                    <IaIcon class="mr-1" size="18" />
                    <span>Essa orientação foi gerada por IA e pode ser incorreta ou inadequada</span>
                </p>
            </div>
            <div v-if="!ia_tools.avaliacaoFeita" class="avaliacao">
                <div class="text-left"><em>Essa resposta foi útil para você?</em></div>
                <div class="d-flex align-items-center mt-1">
                    <b-button size="sm" variant="light" class="mr-1" :disabled="ia_tools.avaliacaoFeita" @click="avaliarResposta(true)">
                        <i class="fa fa-thumbs-up text-success mr-0"></i>
                    </b-button>
                    <b-button size="sm" variant="light" :disabled="ia_tools.avaliacaoFeita" @click="avaliarResposta(false)">
                        <i class="fa fa-thumbs-down text-danger mr-0"></i>
                    </b-button>
                </div>
            </div>
        </div>
        <template #modal-footer>
            <b-button
                v-if="ia_tools.prompt && !ia_tools.conteudoShow"
                class="d-flex mr-auto align-items-center text-primary btn-default"
                @click="gerarResposta(ia_tools.prompt)"
                >
                Entenda com a IA
                <IaIcon class="ml-1" size="22" />
            </b-button>
            <b-button
                v-for="button in buttons"
                :key="button.name"
                :variant="button.variant"
                :value="button.value"
                @click="close(button.value)"
            >
                <i v-if="button.icon" :class="button.icon" /> {{ button.name }}
            </b-button>
        </template>
    </b-modal>
</template>
<script>
import Vue from 'vue'
import IaIcon from '@/shared/components/svg/Ia' 
export default {
    components: {
        IaIcon
    },
    data(){
        return {
            message: '',
            show: false,
            title: null,
            titleClass: null,
            icon: null,
            headerClass: 'text-center border-0 pb-0 flex-column align-items-center',
            bodyClass: 'h5 pt-0 text-center',
            bodyClassContent: 'text-center',
            noCloseOnEsc: false,
            noCloseOnBackdrop: false,
            buttons:[
                {
                    name: 'OK',
                    value: true,
                    variant: 'primary'
                }
            ],
            resolve: undefined,
            reject: undefined,
            ia_tools: {
                prompt: "",
                conteudoShow: false,
                conteudo: "",
                referencia: '',
                avaliacaoFeita: false,
                id_rejeicao: null
            },
        }
    },
    mounted(){
        Vue.prototype.$dialog = {}
        const methods = [
            'success',  'error', 'warning', 'confirm', 'delete'
        ]
        methods.forEach(method => {
            Vue.prototype.$dialog[method] = this[method]
        })
    },
    methods:{
        reset: function() {
            Object.assign(this.$data, this.$options.data())
        },
        merge(options = {}, defaultOptions = {}){
            options = Object.assign(defaultOptions, options)
            return options
        },
        open(message, options = {}){
            this.reset()
            this.show = true
            this.message = message
            for (let data in options) {
                this[data] = options[data];
            }
            return new Promise((resolve, reject) => {
                this.resolve = resolve
                this.reject = reject
            })
        },
        close(value){
            this.show = false
            if (typeof this.resolve == 'function') {
                this.resolve(value)
            }

            document.removeEventListener('keyup', this.enter)
        },
        success(message, options = {}){
            const defaultOptions = {}
            defaultOptions['titleClass'] = 'text-success'
            defaultOptions['icon'] = 'glyphicon glyphicon-ok'
            options = this.merge(options, defaultOptions)
            return this.open(message, options)
        },
        error(message, options = {}){
            const defaultOptions = {}
            defaultOptions['titleClass'] = 'text-danger'
            defaultOptions['icon'] = 'glyphicon glyphicon-remove'
            options = this.merge(options, defaultOptions)
             if(!message){
                message = 'Ocorreu um erro inesperado.'
                options.ia_tools.prompt = false
                this.gerarLog({href: window.location.href})
            }
            if (
                options.ia_tools &&
                typeof options.ia_tools.prompt === 'string' &&
                options.ia_tools.prompt.trim().length > 0 && 
                message != null
                ) {
                this.ia_tools.prompt = options.ia_tools.prompt
                this.ia_tools.referencia = options.ia_tools.referencia || ''
            }
            return this.open(message, options)
        },
        warning(message, options = {}){
            const defaultOptions = {}
            defaultOptions['titleClass'] = 'text-warning'
            defaultOptions['icon'] = 'glyphicon glyphicon-warning-sign'
            options = this.merge(options, defaultOptions)
            return this.open(message, options)
        },
        confirm(message, options = {}){
            const defaultOptions = {}
            defaultOptions['titleClass'] = 'text-primary'
            defaultOptions['icon'] = 'glyphicon glyphicon-question-sign'
            defaultOptions['buttons'] = [
                {
                    name: 'Não',
                    value: false,
                    variant: 'secondary'
                },
                {
                    name: 'Sim',
                    value: true,
                    variant: 'primary'
                }
            ]
            
            setTimeout(() => {
                document.addEventListener('keyup', this.enter)
            }, 300)

            options = this.merge(options, defaultOptions)
            return this.open(message, options)
        },
        delete(message, options = {}){
            const defaultOptions = {}
            defaultOptions['titleClass'] = 'text-danger'
            defaultOptions['icon'] = 'glyphicon glyphicon-trash'
            defaultOptions['buttons'] = [
                {
                    name: 'Não',
                    value: false,
                    variant: 'secondary'
                },
                {
                    name: 'Sim',
                    value: true,
                    variant: 'primary'
                }
            ]
            options = this.merge(options, defaultOptions)
            return this.open(message, options)
        },
        enter (e) {
            if (e.code === "Enter" || e.code === "NumpadEnter") {
                this.close(true)
            }
        },
        async gerarResposta(prompt) {
            const resultado = await this.$api.post(
                `/integracoes/ia/`+ this.ia_tools.referencia,
                { q: prompt }
            )
            if (resultado.status == 'success') {
                this.$set(this.ia_tools, 'conteudoShow', true)
                this.$set(this.ia_tools, 'conteudo', resultado.data.resumo)
                this.$set(this.ia_tools, 'id_rejeicao', resultado.data.id)
            } else {
                this.ia_tools.prompt = false
                this.gerarLog({
                    href: window.location.href,
                    prompt: prompt || '',
                    referencia: this.ia_tools.referencia || '',
                    erro: resultado.message || 'Erro ao gerar resposta'
                })
                this.$notify.error('Não foi possível gerar a resposta')
            }
        },
        async avaliarResposta(avaliacao) {
            const resultado = await this.$api.post(
                `/integracoes/ia/avaliacao`,
                {
                    avaliacao: avaliacao,
                    conteudo: this.ia_tools.conteudo,
                    prompt: this.ia_tools.prompt,
                    referencia: this.ia_tools.referencia,
                    id_rejeicao: this.ia_tools.id_rejeicao
                }
            )
            if (resultado.status == 'success') {
                this.$notify.success(resultado.message)
            } else {
                this.$notify.error('Não foi possível avaliar a resposta')
            }
            this.$set(this.ia_tools, 'avaliacaoFeita', true)
        },
        gerarLog(dados){
            this.$api.cPost(`/integracoes/ia/gerar_log`, dados)
        }

    }
}
</script>
<style>
    .modal-title-icon{
        font-size: 60px
    }
    @media (min-width: 768px) {
        #modal-dialog .modal-dialog {
            margin: 10% auto;
        }
    }
</style>
<style scoped>
.caixa-ia-resposta {
    border: 1px solid #ddd;
    border-radius: 5px;
    padding: 10px 20px 10px;
    margin-top: 1rem;
    font-size: 14px;
    color: #212529;
}

.caixa-ia-resposta .conteudo {
    text-align: left;
}

.caixa-ia-resposta .aviso-gerado {
    font-size: 12px;
    padding-top: 10px;
    color: #007bff;
    margin-bottom: 0;
    text-align: right;
}

.avaliacao {
    font-size: 13px;
    margin-top: 0.5rem;
}

.avaliacao .botoes {
    display: flex;
    align-items: center;
    margin-top: 0.25rem;
}

</style>